import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate} from 'react-router-dom';
import httpService  from '../../api/httpService';
import AlertModal from '../commonComponents/AlertModal';
import uploadImg from '../../assets/images/faces/human-head-image.jpg';
import { useAuth } from '../../contexts/AuthContext';

function ProfileForm({ toggleOffcanvas, isOffcanvasVisible, handleBackdropClick }) {

    const { userDetails } = useAuth();
    const userId = userDetails?.userid;
    const [loading, setLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [profileDetails, setProfileDetails] = useState({
        firstname: '',
        middlename: '',
        lastname: '',
        photo: '',
        email: '',
        phone: '',
        address1: '',
        address2: '',
        country: 0,
        state:'',
        city: '',
        postalcode: ''
    });
    const[countries, setCountries] = useState([]);
    const [photoError, setPhotoError] = useState('');
    const [resetPwdDetails, setResetPwdDetails] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [oldPassword, setOldPassword] = useState('');
    const [matchError, setMatchError] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [oldPasswordError, setOldPasswordError] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertError, setAlertError] = useState(false);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);

    // <----- fetching details for country list ----->
    const fetchCountry = async() =>{
        const orgId = userDetails?.orgId ?? userDetails?.OrgId ?? null;
        const isAdmin = userDetails?.admin === true;
        const url = !isAdmin && orgId != null
            ? `/Country?orgId=${orgId}`
            : '/Country';

        const result = await httpService.getData(url);
        if(result.isSuccess){ 
            setCountries(result.retObject);
        } 
        console.log("User Details", userDetails);    
    } 

    useEffect(() => {
        fetchCountry();    
    }, []);

    // <------- logic to handle input field ------->
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileDetails(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    // <------- Logic for photo upload ------->
    // const handlePhotoUpload = (e) => {
    //     const file = e.target.files[0];
    //     const allowedTypes = ['image/jpeg', 'image/png']; 
    //     const maxSize = 2 * 1024 * 1024; // Maximum file size in bytes (2 MB)   
    //     if (file) {
    //         // Check file type
    //         if (!allowedTypes.includes(file.type)) {
    //             setPhotoError('Only jpeg and png files are allowed.');
    //             return;
    //         }   
    //         // Check file size
    //         if (file.size > maxSize) {
    //             setPhotoError("File size must be less than 2 MB.");
    //             return;
    //         }   
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setProfileDetails((prevDetails) => ({
    //                 ...prevDetails,
    //                 photo: reader.result,
    //             }));
    //             setPhotoError(''); // Clear any previous error
    //         };
    //         reader.readAsDataURL(file);
    //     } else {
    //         setProfileDetails((prevDetails) => ({
    //             ...prevDetails,
    //             photo: '', 
    //         }));
    //         setPhotoError(''); // Clear any previous error
    //     }
    // };

    // <------- logic to handle password input field ------->
    const handlePwdInput = (e) => {
        const { name, value } = e.target;
        setResetPwdDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
        setMatchError('');
        setOldPasswordError('');
    };

    const handleToggleModal = () =>{
        setResetPwdDetails({
            newPassword: '',
            confirmPassword: ''
        });
        setMatchError('');
        setShowPassword(false); 
        setShowConfirmPassword(false);
        setOldPassword(profileDetails.password);
        toggleOffcanvas("pwd-reset-modal");
    }

    // <------- logic to fetch profile details ------->
    useEffect(()=>{
        const fetchData = async () => {
            setIsPageLoading(true);
            try{
                const result = await httpService.getData(`/User/${userId}`);
                const user = result.retObject;
                const address = result.retObject.organization;
                setProfileDetails({
                    firstname: user.firstname || '',
                    middlename: user.middlename || '',
                    lastname: user.lastname || '',
                    photo: user.photo || '',
                    email: address.primconemail || '',
                    phone: address.primconphone || '',
                    address1: address.address1 || '',
                    address2: address.address2 || '',
                    country: address.country || 0,
                    state: address.state || '',
                    city: address.city || '',
                    postalCode: address.postalcode || ''
                });
            }catch(err){
                console.error("Error in fetching details:", err);
            }finally {
                setIsPageLoading(false);
            }
        }
        fetchData();
    }, [userId]);

    const handleCloseModal = () => {
        setIsAlertModalOpen(false);
    };

    // <------- logic to reset password ------->
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setMatchError('');
        setOldPasswordError('');

        if (!oldPassword) {
            setOldPasswordError("Please enter your old password");
            return;
        }
        if (!resetPwdDetails.newPassword) {
            setMatchError("Please enter your new password");
            return;
        }
        if (resetPwdDetails.newPassword !== resetPwdDetails.confirmPassword) {
            setMatchError("New Password and Confirm Password must be the same.");
            return;
        }
        try {
            setIsLoading(true);
            const payload = {
                userId: userId,
                newPassword: resetPwdDetails.newPassword,
                oldPassword: oldPassword
            };
            console.log(payload); //return;
            const result = await httpService.postData(`/ResetPassword`, payload);
            if (result.isSuccess) {
                setAlertMessage("Password updated successfully");
                setAlertError(false);
                setIsAlertModalOpen(true);
            } else {
                console.log(result.message);
                setOldPasswordError(result.message);
            }
        } catch (error) {
            console.log('Failed to reset password:', error);
            setMatchError("Failed to reset the password .");
        } finally {
            setIsLoading(false);
        }
    };

    // <------ handle form submission ------->
    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            setLoading(true);
            const payload = {
                ...profileDetails,
                addedBy: "ABC"
            };
            console.log(payload);
            // const result = await httpService.putData(`/User/${userId}/UserProfile`, payload);
            // if(result.isSuccess){
            //     setAlertMessage("Profile has been sucessfully updated !");
            //     setAlertError(false);
            //     setIsAlertModalOpen(true);
            // }else{
            //     //setResponseError(result.message);
            // }
        }catch(error){
            console.error('Failed to post data:', error);
        }finally {
            setLoading(false);
        }
    }

    return (
        <div className="app-content p-4">
            <div className="container-fluid mt-4">
                <div className="card custom-card create-user-card">
                    <div className="card-header justify-content-between">
                        <div className="card-title">Welcome, {profileDetails.firstname} {profileDetails.lastname}</div>
                    </div>
                    <div className="card-body">
                        {isPageLoading ? (
                            <div className="d-flex justify-content-center align-items-center loader-container">
                                <button className="btn btn-outline-secondary mt-3" type="button">
                                    <span className="spinner-border spinner-border-sm align-middle me-2" role="status"
                                        aria-hidden="true"></span>
                                    Loading...
                                </button>
                            </div>
                        ):( 
                            <>
                                <form>
                                    <div className="row mt-3 pb-5">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <h6 className='col-sm-11 sub-section-heading'> Personal Details: </h6>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="firstname" className="col-sm-4 col-form-label">First Name :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="firstname" id="firstname" value={profileDetails.firstname} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="middlename" className="col-sm-4 col-form-label">Middle Name :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="middlename" id="middlename" value={profileDetails.middlename} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="lastname" className="col-sm-4 col-form-label">Last Name :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="lastname" id="lastname" value={profileDetails.lastname} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="email" className="col-sm-4 col-form-label">Email :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="email" id="email" value={profileDetails.email} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="phone" className="col-sm-4 col-form-label">Phone Number :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="phone" id="phone" value={profileDetails.phone} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="password" className="col-sm-4 col-form-label">Password :</label>
                                                <div className="col-sm-6">
                                                    <Link type="button" className="btn btn-outline-secondary btn-sm btn-wave mb-3 mt-2" onClick={(e) => { e.stopPropagation(); handleToggleModal();}}>
                                                        <i className="fa-solid fa-key fa-sm side-menu__icon me-1 align-middle d-inline-block"></i>Change Password
                                                    </Link>
                                                </div>
                                            </div>
                                           {/*  <div className="mb-3 row">
                                                <label htmlFor="inputPhoto" className="col-sm-4 col-form-label">Photo:</label>
                                                <div className="col-sm-3 position-relative">                                       
                                                    <div className="image-upload-container">
                                                        <img src={profileDetails.photo || uploadImg} alt="Uploaded Preview" className="uploaded-image"/>
                                                        <div className="camera-icon"  onClick={() => document.getElementById('photoInput').click()} >
                                                            <i className="fa fa-camera"></i>
                                                        </div>
                                                        <input type="file" id="photoInput"
                                                            accept="image/*" onChange={handlePhotoUpload}                                                                                 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 mt-3 photo-error-msg">
                                                    {photoError && <div className="text-danger">{photoError}</div>}
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <h6 className='col-sm-11 sub-section-heading'> Address Details: </h6>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="address1" className="col-sm-4 col-form-label">Address Line 1 :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="address1" id="address1" value={profileDetails.address1} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="address2" className="col-sm-4 col-form-label">Address Line 2 :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="address2" id="address2" value={profileDetails.address2} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="city" className="col-sm-4 col-form-label">City :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="city" id="city" value={profileDetails.city} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="state" className="col-sm-4 col-form-label">State :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="state" id="state" value={profileDetails.state} onChange={handleInputChange} disabled/>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="country" className="col-sm-4 col-form-label">Country :</label>
                                                <div className="col-sm-6">
                                                    <select id="country" className="form-select" name="country" value={profileDetails.country} onChange={handleInputChange} disabled>
                                                        <option value="">Select</option>
                                                        {countries.map((item, index) => (
                                                            <option key={index} value={item.countryId}>
                                                                {item.countryName}
                                                            </option>
                                                        ))}                                                                 
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="postalcode" className="col-sm-4 col-form-label">Postal Code :</label>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" name="postalcode" id="postalcode" value={profileDetails.postalcode} onChange={handleInputChange} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {isOffcanvasVisible && (isOffcanvasVisible === 'pwd-reset-modal') && (
                <div>
                    <div className="backdrop" onClick={handleBackdropClick}></div>
                    <div id="contactModal" className={`modal fade show`} tabIndex="-1" aria-labelledby="contactModal" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel2">Reset Password</h5>
                                    <button type="button" onClick={handleToggleModal} className="btn-close" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label htmlFor="oldPassword" className="col-form-label">Old Password :</label>
                                                <div className='position-relative'>
                                                <input type={showOldPassword ? "text" : "password"} className="form-control" name="oldPassword" value={resetPwdDetails.oldPassword} onChange={(e) => setOldPassword(e.target.value)}/>
                                                    <i
                                                        className={`fa-regular fa-sm ${showOldPassword ? "fa-eye" : "fa-eye-slash"} password-toggle-onPage admin-pwd-reset`}
                                                        onClick={() => setShowOldPassword(!showOldPassword)}>
                                                    </i>
                                                </div>       
                                            </div>
                                            {oldPasswordError && <div className="text-danger">{oldPasswordError}</div>}
                                            <div className="col-md-12 mb-2 mt-2">
                                                <label htmlFor="newPassword" className="col-form-label">New Password :</label>
                                                <div className='position-relative'>
                                                <input type={showPassword ? "text" : "password"} className="form-control" name="newPassword" value={resetPwdDetails.newPassword} onChange={handlePwdInput}/>
                                                    <i
                                                        className={`fa-regular fa-sm ${showPassword ? "fa-eye" : "fa-eye-slash"} password-toggle-onPage admin-pwd-reset`}
                                                        onClick={() => setShowPassword(!showPassword)}>
                                                    </i>
                                                </div>   
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="confirmPassword" className="col-form-label">Confirm Password :</label>
                                                <div>
                                                    <div className='position-relative'>
                                                        <input  type={showConfirmPassword? "text" : "password"} className="form-control" 
                                                            name="confirmPassword" 
                                                            value={resetPwdDetails.confirmPassword} 
                                                            onChange={handlePwdInput}
                                                        />
                                                        <i
                                                            className={`fa-regular fa-sm ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"} password-toggle-onPage admin-pwd-reset`}
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                        </i>
                                                    </div>
                                                    {matchError && <div className="text-danger">{matchError}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2 mt-4 mb-2">
                                                {isLoading ? (
                                                    <div className='save-btn-with-loader'>
                                                        <button className="btn blue-btn mt-3 me-2">Save</button>
                                                        <div className="spinner-border text-primary mt-3" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                ):(
                                                    <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleResetPassword}>Save</button>
                                                )}
                                            </div>
                                        </div>                          
                                    </form>
                                </div>
                                <div className="modal-footer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <AlertModal
                isOpen={isAlertModalOpen}
                onClose={() => handleCloseModal()}
                title={alertMessage}
                error={alertError}
            />
        </div>
    );
}

export default ProfileForm;